import { render, staticRenderFns } from "./SearchResultItem.vue?vue&type=template&id=2b044da8&"
import script from "./SearchResultItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports